/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "@/components/ui/sonner";
import { Board } from "./components/Board";
import { Settings } from "./components/Settings";
import { BrowserRouter, Routes, Route } from "react-router";
import { ThemeProvider } from "./components/theme-provider";

export const MOOD_OPTIONS = [
  { label: "Très heureux 😁", color: "bg-emerald-500 hover:bg-emerald-600" },
  { label: "Heureux 😊", color: "bg-lime-500 hover:bg-lime-600" },
  { label: "Normal 😐", color: "bg-yellow-500 hover:bg-yellow-600" },
  { label: "Triste 😢", color: "bg-orange-500 hover:bg-orange-600" },
  { label: "Très triste 😭", color: "bg-red-500 hover:bg-red-600" },
];

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <ThemeProvider defaultTheme="system" storageKey="vite-ui-theme">
      <BrowserRouter>
        <Routes>
          <Route index element={<Board />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
